/**
 * Single dev toggle for galleries + FSI languages (mirrors scripts/lib/localMediaDev.cjs).
 *
 * REACT_APP_LOCAL_DISK=0 — remote media via backend signer (Aliyun OSS; same-origin /oss-light/) (default)
 * REACT_APP_LOCAL_DISK=1 — local disk: I:/mgv-assets/gallery + I:/fsi-prod/{Language}
 *
 * Restart npm start after changing.
 */

export function isLocalDiskDev() {
  const flag = process.env.REACT_APP_LOCAL_DISK;
  if (flag === '1') return true;
  if (flag === '0') return false;
  if (process.env.REACT_APP_FSI_ALL_USE_DISK === '1') return true;
  if (process.env.REACT_APP_FSI_FRENCH_USE_DISK === '1') return true;
  if (process.env.REACT_APP_FSI_RUSSIAN_USE_DISK === '1') return true;
  return false;
}

export function isRemoteMediaDev() {
  return !isLocalDiskDev();
}
